var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1260"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1260"
    },
    "bundlingPackage": "portals-platform-reference-fe",
    "bundlingPackageVersion": "static-1.1464",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};